import React, { useCallback, useState, useEffect } from 'react'
import { useTenants } from '../../context/tenants'
import TenantListItem from './tenantListItem'
import numeral from 'numeral'
import Paging from '../paging/paging'
import useKeyPressEffect from '../../hooks/useKeyPress'

const TenantsList = (props) => {
  const { tenants, page, setPage, pageSize, total } = useTenants()

  const [arrowIndex, setArrowIndex] = useState(-1)

  const onSetPage = useCallback((currentPage) => {
    setPage(currentPage)
  }, [])

  useKeyPressEffect({
    targetKey: 'ArrowUp',
    eventTarget: ['#searchBox'],
    onDown: () => {
      if (arrowIndex > -1) {
        setArrowIndex(arrowIndex - 1)
      }
    }
  }, [arrowIndex])

  useKeyPressEffect({
    targetKey: 'ArrowDown',
    eventTarget: ['#searchBox'],
    onDown: () => {
      if (arrowIndex < tenants.length) {
        setArrowIndex(arrowIndex + 1)
      }
    }
  }, [arrowIndex, tenants])

  const onMouseOver = useCallback((i) => {
    setArrowIndex(i)
  }, [])

  return (
    <>
      <div className="flex-table">
        <div className="thead">
          <div className="tr border-b border-color-c9ced0">
            <div className="td w-48">Name</div>
            <div className="td w-10">Status</div>
            <div className="td w-10">Region</div>
            <div className="td w-10 text-right" />
          </div>
        </div>
        <div className="tbody">
          {tenants.map((tenant, i) => (
            <TenantListItem
              i={i}
              onMouseOver={onMouseOver}
              selected={i === arrowIndex}
              key={`TenantListItem-${tenant.id}-${i}`}
              tenant={tenant} />
          ))}
        </div>
      </div>
      <Paging
        className="flex w-full items-center justify-between py-3"
        textClassName="text-color-151d49 text-size-15px font-weight-600"
        navigationClassName="flex items-center"
        total={total}
        limit={pageSize}
        page={page}
        onSetPage={onSetPage}
        textFormatter={(start, end, totalPages) => `${numeral(start).format('0,0')} - ${numeral(end).format('0,0')} of ${numeral(totalPages).format('0,0')}`} />
    </>
  )
}

export default TenantsList
